import type { ReactNode } from "react"

import { cn } from "@/shared/utils/cn"

export interface PageShellProps {
  children: ReactNode
  className?: string
  /** 页面背景色，默认浅灰 page */
  bg?: string
}

/**
 * 落地页最外层容器：移动端满宽、桌面预览居中并限制最大宽度，
 * 配合 fixed 的 StickyCta / WechatOpenGuide 使用。
 */
export function PageShell({ children, className, bg = "bg-page" }: PageShellProps) {
  return (
    <div
      className={cn(
        "relative mx-auto min-h-screen w-full max-w-[480px] bg-white shadow-card",
        bg,
        className,
      )}
    >
      {children}
    </div>
  )
}
